export default __webpack_public_path__ + "static/media/sustainabilityData.d288ba67.jpg";